export function handleFocusOnId(id: string): void {
    const elementToFocus = document.getElementById(id)
    elementToFocus?.focus()
    elementToFocus?.scrollIntoView({ behavior: 'smooth', block: 'center' })
}
